jQuery(function ($, undefined) {
	// Need to be in consistent with com.etix.ticketing.eventSeries.TimedEntryItemType
	const ITEM_TYPE_PERF = 0;
	const ITEM_TYPE_FULL_PACK = 1;
	const ITEM_TYPE_FLEX_PACK = 2;
	var CAL_API_URL = Etix.javaAPIContext + '/onlineSale/timedEntry/'+ event_id +'/dayData';
	var monthSummaryUrl = Etix.javaAPIContext + '/onlineSale/timedEntry/'+ event_id +'/monthData';
	var redirectUrl = Etix.javaAPIContext + '/onlineSale/timedEntry/'+ event_id +'/soldOutDayDescription';
	var params = {};
	if(campaign_id) {
		params.campaign_id = campaign_id;
	}
	var currentYear = defaultDate.getFullYear();
	var currentMonth = defaultDate.getMonth() + 1;
	var currentDay = defaultDate.getDate();
	//cache data of each month by day.
	var monthData = {};
	var monthAfterChange = currentMonth;
	var yearAfterChange = currentYear;
	var notAvailableDays = {};
	var pastDays = {};
	var noEventDays = {};
	var soldOutDays = {};
	var showAccessibilityLabels = $('#showAccessibilityLabels').val();
	var firstLoad = true;

	function loadingDates() {
		$('th.datepicker-switch').contents().filter(function() {return this.nodeType ==3;}).wrap('<span class="month-year">');
		$('span.month-year').hide();
		$('th.datepicker-switch').append('<span class="loading-dates spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');

		// TODO: (ENG-1439) These show() and hide() lines are here to disable the loading indicator and show the month and year immediately, because the indicator doesn't work properly. Remove these lines after the loading indicator is fixed.
		$('.loading-dates').hide();
		$('.month-year').show();

    // Needed so screen readers announce these elements as buttons, and so
    // Narrator will activate them when user presses enter key
    $('.prev, .next, .day:not(.disabled)').attr('role', 'button');
	}

  function applyButtonRoleToActiveDays() {
    $('.day:not(.disabled)').attr('role', 'button');
  }

  // Watch for DOM changes and apply role attribute to days whenever they render
  function observeCalendarChanges() {
    const calendarContainer = document.querySelector('#datepicker-embeded');

    if (!calendarContainer) return;

    const observer = new MutationObserver(function(mutations) {
        // Debounce to avoid running on every single mutation
        clearTimeout(observer.debounceTimer);
        observer.debounceTimer = setTimeout(function() {
            applyButtonRoleToActiveDays();
        }, 50);
    });

    observer.observe(calendarContainer, {
        childList: true,      // Watch for added/removed nodes
        subtree: true,        // Watch all descendants
        attributes: true,     // Watch for attribute changes (like class changes from disabled to enabled)
        attributeFilter: ['class'] // Only watch class attribute changes
    });
  }

	function wrapDateHtml() {
    // Use aria-hidden and let screen readers read the date and price from a
    // deidicated .sr-only div to prevent voiceover reading the info twice
		$('.day').contents().filter(function() {return this.nodeType ==3;}).wrap('<div class="day-date" aria-hidden="true">');
	}

	function makeMonthArrowsTabbable(clickedButton) {
		// For ADA, make month arrows tabbable if enabled
		if ($('.prev').hasClass('disabled')) {
			$('.prev').attr('tabindex', '-1');
		} else {
			$('.prev').attr('tabindex', '0');
		}

		if ($('.next').hasClass('disabled')) {
			$('.next').attr('tabindex', '-1');
		} else {
			$('.next').attr('tabindex', '0');
		}

		// Do not focus on a button that has disabled styling
		if (clickedButton !== undefined && clickedButton.hasClass('disabled')) {
			clickedButton.blur();
		}
	}

	// Use skip-to-content link to skip to month/year calendar heading for keyboard and screen reader users
	$(document).on('click', '.skip-nav', function (e) {
		e.preventDefault();

		// .month-year only shows on the first month when page first loads. If user changes months, focus on .datepicker-switch instead
		if ($('.month-year').length) {
			$('.month-year').focus();
		} else if ($('.datepicker-switch').length) {
			$('.datepicker-switch').focus();
		}
	})

	$(document).ready(function () {
		loadingDates();
		wrapDateHtml();
		initDialog();
		makeMonthArrowsTabbable();
    observeCalendarChanges();
	});

	function initDialog(){
		$("#sold_out_dialog").dialog({
			autoOpen: false,
			modal: true,
			width: 500,
			height: 300,
			buttons: {
				Close: function () {
					$(this).dialog('close');
				}
			}
		});
	}

	function hover(){
		if (redirect) {
			$('#datepicker-embeded').find('.day.disabled').hover(function () {
				$(this).css("cursor", "pointer");
			});
		}
	}

	function hideLegend(){
		var available = monthData[getYearMonthKey()].monthSummary;
		var notAvailable = notAvailableDays[getYearMonthKey()].notAvailable;
		applyHide(available, '.available');
		applyHide(notAvailable, '.notAvailable');
		applySoldOut();
	}

	function applyHide(days, clz){
		if (Object.keys(days).length === 0 && days.constructor === Object) {
			$('#datepicker-embeded').find('.legend').find(clz).css("display", "none");
		} else {
			$('#datepicker-embeded').find('.legend').find(clz).css("display", "block");
		}
	}

	function applySoldOut(){
		var soldOut = soldOutDays[getYearMonthKey()].soldOutDay;
		if (Object.keys(soldOut).length === 0 && soldOut.constructor === Object) {
			$('#datepicker-embeded').find('.legend').find('.soldOut').css("display", "none");
			$('#datepicker-embeded').find('.legend').find('.soldOutRedirect').css("display", "none");
		} else {
			if (redirect) {
				$('#datepicker-embeded').find('.legend').find('.soldOutRedirect').css("display", "block");
			} else {
				$('#datepicker-embeded').find('.legend').find('.soldOut').css("display", "block");
			}
		}
	}

	function clickRedirectDay(){
		if (redirectDay != "") {
			$(".datepicker-days td:not(.old):not(.new):eq(" + (parseInt(redirectDay) - 1) + ")").trigger('click');
			hover();
		}
	}

	function setNotAvailableColor(){
		var unavailableDays = notAvailableDays[getYearMonthKey()].notAvailable;
		applyColor(unavailableDays, notAvailableColor.split("-")[1], false);
		applyAccessibilityStatusLabel(unavailableDays, false, 'NA');
	}

	function setPastDayColor(){
		var past = pastDays[getYearMonthKey()].pastDay;
		applyColor(past, pastDayColor.split("-")[1], true);
	}

	function setNoEventDayColor(){
		var noEvent = noEventDays[getYearMonthKey()].noEventDay;
		applyColor(noEvent, noEventDayColor.split("-")[1], false);
		applyAccessibilityStatusLabel(noEvent, false, 'NE');
	}

	function setSoldOutDayColor(){
		var soldOut = soldOutDays[getYearMonthKey()].soldOutDay;
		if (redirect) {
			applyColor(soldOut, soldOutRedirectColor, false);
			applyAccessibilityStatusLabel(soldOut, false, 'SOR');
		} else {
			applyColor(soldOut, soldOutColor.split("-")[1], false);
			applyAccessibilityStatusLabel(soldOut, false, 'SO');
		}
	}

	function applyColor(days, color, isPast) {
		$.each(days, function (d, p) {
			var day = $(".datepicker-days td:not(.old):not(.new):eq(" + parseInt(d - 1) + ")");
			day.css("background", color);
			if (isPast) {
				day.css("opacity", 0.5);
				day.attr("aria-labelledby", d);
			}
		});
	}

	// Accessibility status labels can be turned on/off in Edit Timed Entry admin page
	function applyAccessibilityStatusLabel(days, isPast, status) {
		if (showAccessibilityLabels !== 'false') {
			$.each(days, function (d) {
				var day = $(".datepicker-days td:not(.old):not(.new):eq(" + parseInt(d - 1) + ")");
				if (!isPast) {
					day.append('<div class="day-status" style="background: #fff; margin: 5px 0; border-radius: 10px; font-size: 12px;">' + status + '</div>');
				} else {
					day.css("opacity", 0.5);
					day.attr("aria-labelledby", d);
				}
			});
		}
	}

	function getYearMonthKey() {
		return currentYear + ',' + currentMonth;
	}

	function getSeries(beginDay) {
		if ( typeof(currentMonth) !== 'undefined' && typeof(currentYear) !== 'undefined' ) {
			params.year = currentYear;
			params.month = currentMonth;
		}

		startAjaxSpinner();
		$.ajax({
			url: monthSummaryUrl + '?' + $.param(params),
			dataType: "json",
			success: function(monthSummary) {
				stopAjaxSpinner();

				var yearMonthKey = getYearMonthKey();

				monthData[yearMonthKey] = {};
				notAvailableDays[yearMonthKey] = {};
				pastDays[yearMonthKey] = {};
				noEventDays[yearMonthKey] = {};
				soldOutDays[yearMonthKey] = {};
				monthData[yearMonthKey].monthSummary = monthSummary[availableColor];
				notAvailableDays[yearMonthKey].notAvailable = monthSummary[notAvailableColor];
				pastDays[yearMonthKey].pastDay = monthSummary[pastDayColor];
				noEventDays[yearMonthKey].noEventDay = monthSummary[noEventDayColor];
				soldOutDays[yearMonthKey].soldOutDay = monthSummary[soldOutColor];

				for(var key in monthSummary[availableColor]) {
					if(monthSummary[availableColor].hasOwnProperty(key)) {
						if(key < beginDay) {
							delete monthSummary[availableColor][key];
						}
					}
				}

				enableDays(false);
				hideLegend();
				setNotAvailableColor();
				setPastDayColor();
				setNoEventDayColor();
				setSoldOutDayColor();
			},
			error: function(xhr) {
				stopAjaxSpinner();
			}
		});
	}

	// For use in aria-label
	function getMonthName(monthNumber) {
		const date = new Date();
		date.setMonth(monthNumber - 1);

		return date.toLocaleString(language, {
			month: 'long',
		});
	}

	function focusOnMonthYearOnCalendar() {
		// Don't focus on month/year calendar heading on page load, to prevent focus highlight from showing. It will still show if tabbed to by keyboard users though.
		if (!firstLoad) {
			// Focus on the month/year heading on calendar when next month button is clicked so new month is read to user immediately when new month loads
			$('.datepicker-switch').focus();
		}
	}

	function enableDays(clicked) {
		var monthSummary = monthData[getYearMonthKey()].monthSummary;

		if(Object.keys(monthSummary).length === 0 && monthSummary.constructor === Object && !redirect) {
			showNoEventsMessageOnCalendar();
		}

		if (Object.keys(monthSummary).length === 0) {
			$('.datepicker-switch').first().attr({
				'aria-label': $('.datepicker-switch').first().text()  + " - There are no available days this month",
				'tabindex': 0
			});

			focusOnMonthYearOnCalendar();
		} else {
			$('.datepicker-switch').attr({
				'aria-label': $('.datepicker-switch').first().text()  + " - Press tab to cycle through available days for this month",
				'tabindex': 0
			});

			focusOnMonthYearOnCalendar();
		}

		firstLoad = false;

		$.each(monthSummary, function(day, maxPrice) {
			var days = $(".datepicker-days td:not(.old):not(.new):eq(" + parseInt(day-1) + ")");
			days.removeClass('disabled');

			// For ADA, make days tabbable after they enable;
			days.attr('tabindex', '0');

			if(!clicked){
				days.css("background", availableColor.split("-")[1]);
			}

			if(maxPrice) {
				days.append('<div class="day-price" aria-hidden="true">' + maxPrice + '</div>')
			}

      // Screen readers read the date and price from here
      days.append('<div class="sr-only">' + getMonthName(currentMonth) + ' ' + days.text() + '. Press enter to browse available times.</div>')
		});
	}

	function showNoEventsMessageOnCalendar() {
		$(".datepicker-embeded").prepend("<span class='not-available-overlay'></span>");
		$(".datepicker-embeded").prepend('<span class="not-available-text">' + noUpcomingEventMessage + '</span>');

		var headHeight = $(".table-condensed thead").height();
		var tableHeight = $(".table-condensed").height();
		var tableWidth = $(".table-condensed").width();
		var overlayHeight = tableHeight - headHeight;
		$('.not-available-overlay').css('height', overlayHeight);
		$('.not-available-overlay').css('width', tableWidth);
		$('.not-available-text').css('height', overlayHeight);
	}

	function hideNoEventsMessageOnCalendar() {
		$(".not-available-overlay").remove();
		$(".not-available-text").remove();
	}

	function showNoEventsMessageForButtonNext() {
		var ttText = "<div class='tooltip bs-tooltip-bottom' role='tooltip' id='toolTipOfNoUpcomingEvents' style='opacity:1;'><div class='arrow'></div><div class='tooltip-inner'>"+noUpcomingEventMessage+"</div></div>";
		console.log(ttText);
		$('.datepicker table thead .next').append(ttText);
	}

	function hideNoEventsMessageForButtonNext() {
		$('#toolTipOfNoUpcomingEvents').remove();
	}

	function appendTimes(selectedDate) {
		enableDays(true);
		wrapDateHtml();

    const timeDropdown = $('#js-timeslot select');

		if ( timeDropdown.children().length > 0 ) {
			timeDropdown.empty();
		}

		var dataDefaultOp = timeDropdown.attr('data-defaultOp');
    timeDropdown.append($('<option class="default">'+ dataDefaultOp + '</option>'));

		var localeCountry = $('#locale_country').val();

		//internationalize the sports left
		var spotsLeft = $("#timedEntry_spotsLeft").val();

		var dayData = monthData[getYearMonthKey()][selectedDate];

		for(var i = 0; i < dayData.length; i++) {
			perfData = dayData[i];
			var availableTimes = perfData.compoundTime, timeId = perfData.id;

			if ( parseInt(perfData.open) > -1 ) {
				availableTimes += " (" + perfData.open + " " + spotsLeft + ")";
			}

			$('#js-timeslot').hide();

			setTimeout(function () {
				$('#js-timeslot').show().find('.select').removeClass('select--disabled');
			}, 100);

			$('.select select').prop('disabled', false);
			timeDropdown.append('<option data-midnight="' + perfData.midnightMessage + '" data-id="' + timeId + '" data-item-type ="' + perfData.timedEntryItemType + '" >' + availableTimes + '</option>');

			if ( parseInt(perfData.open) === 0 ) {
				$('#js-timeslot select option[data-id=' + timeId + ']').prop("disabled", true);
			}
		}
	}

	function changeYearMonth( dir ) {
		var today = startDate;

		if ( dir === 'fa fa-angle-left' && currentYear + '' + currentMonth === today.getFullYear() + '' + (today.getMonth()+1) ) {
			var monthSummary = monthData[getYearMonthKey()].monthSummary;
			if (Object.keys(monthSummary).length === 0 && monthSummary.constructor === Object && !redirect) {
				showNoEventsMessageOnCalendar();
			}
			return false;
		}

		if ( dir === 'fa fa-angle-left' ) {
			currentMonth = currentMonth > 1 ? --currentMonth : 12;

			if ( currentMonth === 12 ) {
				--currentYear;
			}
		} else if ( dir === 'fa fa-angle-right' ) {
			currentMonth = currentMonth < 12 ? ++currentMonth : 1;

			if ( currentMonth === 1 ) {
				++currentYear;
			}
		}
		$('.next').removeClass('disabled');
		$('.fa-angle-right').closest('th').off('mouseenter mouseleave');
		handleLastAvailableMonth();
		if(!monthData[getYearMonthKey()] || !notAvailableDays[getYearMonthKey()] || !pastDays[getYearMonthKey()] || !noEventDays[getYearMonthKey()] || !soldOutDays[getYearMonthKey()]) {
			//load data by ajax.
			getSeries(1);
		} else {
			hideLegend();
			enableDays(false);
			setNotAvailableColor();
			setPastDayColor();
			setNoEventDayColor();
			setSoldOutDayColor();
		}
		wrapDateHtml();
		hideDays();
	}

	function handleLastAvailableMonth() {
		if(currentYear >= lastAvailableYear && currentMonth >= lastAvailableMonth) {
			$('.next').addClass('disabled');
			$('.fa-angle-right').closest('th').hover(function() {
				showNoEventsMessageForButtonNext();
			}, function() {
				hideNoEventsMessageForButtonNext();
			});
		}
	}

	$(document).on('click', '.day:not(.disabled)', function() {
		// to make the disabled day clickable and no background color
		$("#midnight_message").hide();
		hover();
		setNotAvailableColor();
		setPastDayColor();
		setNoEventDayColor();
		setSoldOutDayColor();
		var href = $('.timeslot .button').attr('href').replace(/\=.*/,'=');

		// Untabbable because disabled
    $('.timeslot .button').addClass('button--disabled').attr({href: href, tabindex: -1, 'aria-disabled': 'true'}).bind('click', false);

		var dayText = $(this).find('div.day-date').text();
		var day = parseInt(dayText);
		if (isNaN(day)) {
			day = dayText;
		}
		var yearMonthKey = getYearMonthKey();
		var dayData = monthData[yearMonthKey][day];
		if (!dayData) {
			if (typeof (currentMonth) !== 'undefined' && typeof (currentYear) !== 'undefined') {
				params.year = currentYear;
				params.month = currentMonth;
				params.day = day;
			}

			startAjaxSpinner();
			$.ajax({
				url: CAL_API_URL + '?' + $.param(params),
				dataType: "json",
				success: function (daysData) {
					stopAjaxSpinner();
					if (daysData.length > 0) {
						monthData[yearMonthKey][day] = daysData;
					} else {
						monthData[yearMonthKey][day] = [];
					}
					appendTimes(day);

					setTimeout(function() {
						// Focus on time selector after a date is selected
						$('#js-timeslot-select').focus();
					}, 100);
				},
				error: function (xhr) {
					stopAjaxSpinner();
					enableDays(true);
					wrapDateHtml();
				}
			});
		} else {
			appendTimes(day);

			setTimeout(function() {
				// Focus on time selector after a date is selected
				$('#js-timeslot-select').focus();
			}, 100)
		}
		hideDays();
		var monthSummary = monthData[getYearMonthKey()].monthSummary;
		$.each(monthSummary, function(d, maxPrice) {
			if (d != day) {
				var days = $(".datepicker-days td:not(.old):not(.new):eq(" + parseInt(d - 1) + ")");
				days.css("background", availableColor.split("-")[1]);
			}
		});
	});

	$(document).on('click', '.day.disabled', function() {
		var dayText = $(this).find('div.day-date').text();
		var clickedDay = parseInt(dayText);
		var year = startDate.getFullYear();
		var month = startDate.getMonth() +　1;
		var soldOut = soldOutDays[getYearMonthKey()].soldOutDay;
		if(Object.keys(soldOut).length === 0 && soldOut.constructor === Object){
			return false;
		}
		var isClickedDaySoldOut = false;
		for(var key in soldOut) {
			if(soldOut.hasOwnProperty(key)) {
				if(key == clickedDay) {
					isClickedDaySoldOut = true;
					break;
				}
			}
		}
		if (!isClickedDaySoldOut) {
			return false;
		}
		if ((yearAfterChange == year && monthAfterChange == month && clickedDay < startDate.getDate()) || !redirect || (yearAfterChange == year && monthAfterChange < month) || yearAfterChange < year) {
			return false;
		}
		if ( typeof(currentMonth) !== 'undefined' && typeof(currentYear) !== 'undefined' ) {
			params.year = currentYear;
			params.month = currentMonth;
			params.day = clickedDay;
		}
		startAjaxSpinner();
		$.ajax({
			url: redirectUrl + '?' + $.param(params),
			dataType: "text",
			success: function (redirectDescription) {
				stopAjaxSpinner();
				openRedirectDialog(redirectDescription);
			},
			error: function (jqXhr, textStatus, errorMessage) {
				stopAjaxSpinner();
				openRedirectDialog(errorMessage);
			}
		});
	});

	// open dialog to select another event when the selected event is sold out or alert error message
	function openRedirectDialog(message) {
		$("#sold_out_dialog").html(message);
		$("#sold_out_dialog").dialog('open');
	}

	$(document).on('click', '.prev, .next', function(e) {
		hover();
		$("#midnight_message").hide();
		if(skip === 0) {
			if($(this).is('.next.disabled')) {
				return false;
			}
			var dir = $(this).find('i').attr("class");
			hideNoEventsMessageOnCalendar();
			changeYearMonth(dir);
			$('.datepicker').find('td.active').removeClass('active');
		}
		var clickedBtn = $(e.target)

		setTimeout(makeMonthArrowsTabbable(clickedBtn), 500);
	});

	$(window).on("load", function() {
		hover();
		if(!$('#datepicker-embeded').find('.today.day').hasClass('disabled') && redirectDay == ""){
			$('#datepicker-embeded').find('.today.day').trigger('click');
		}
		clickRedirectDay();
	});

	if ( $('.timeslot .button').length > 0 ) {
		var href = $('.timeslot .button').attr('href').replace(/\=.*/,'=');
	}

	$('#datepicker-embeded').datepicker({
		todayHighlight: true,
		daysOfWeekDisabled: '0, 1, 2, 3, 4, 5, 6',
		language: language,
		startDate: startDate
	}).on('changeMonth', function(e) {
		monthAfterChange = new Date(e.date).getMonth() + 1;
		yearAfterChange  = new Date(e.date).getFullYear();
		if ( $('.timeslot select').children().length > 0 ) {
			$('.timeslot select').empty();
		}

		$('.timeslot').hide();
		$('.timeslot').find('.select').addClass('select--disabled');
		$('.select select').prop('disabled', true);

		// Untabbable because disabled
		$('.timeslot .button').addClass('button--disabled').attr({href: href, tabindex: -1, 'aria-disabled': 'true'}).bind('click', false);
	});

	var skip = defaultDate.getMonth() - startDate.getMonth();

	// defaultDate is the first date with a sellable performance
	// startDate is the current date
	// Calculate the number of months that need to be skipped to get to the first month and year with sellable performances
	if (defaultDate > startDate) {
		skip = ((defaultDate.getFullYear() - startDate.getFullYear()) * 12) + (defaultDate.getMonth() - startDate.getMonth());
	}

	//skip no sales months.
	while(skip > 0) {
		$('.next')[0].click();
		skip--;
	}

	if ( $('.series').length > 0 ) {
		// For IE8 and IE9
		$('.timeslot .button').bind('click', false);


		// For IE8 and IE9
		$('select').on('change', function() {
			$(this).trigger('blur');
		})


		// For IE8 and IE9
		$('select > option').on('click', function() {
			$(this).parent().trigger('blur');
		})


		//This is an IE fix because pointer-events do not work in IE
		$('.datepicker-switch').on('click', function ( e ) {
			return false;
		});


		$('select').on('change', function() {
			var queryString = $("#query_string").val();
			var buttonId = $(this).find('option:selected').data('id');
			//DEV-14349 Performance or Package
			var itemType = $(this).find("option:selected").data("item-type")
			$('#midnight_message').hide();
			var midnightMessage = $(this).find("option:selected").data("midnight")
			if (midnightMessage !== undefined && midnightMessage !== 'undefined') {
				$('#midnight_message').html(midnightMessage);
				$('#midnight_message').show(300, "swing");
			}
			$('.timeslot .button').attr('href', href);
			if (campaign_id) {
				$('.timeslot .button.reserve').attr('href', href);
			}else {
				//DEV-14349 Performance
				if(itemType === ITEM_TYPE_PERF){
					$('.timeslot .button.reserve').attr('href', href.replace('p/', 'online/performanceReserve.jsp?performance_id='));
				}else{
					//DEV-14349 full package or flex package
					$('.timeslot .button.reserve').attr('href', href.replace('p/', 'online/packageReserve.jsp?package_id='));
				}
			}
			if ( buttonId === undefined ) {
				// Untabbable because disabled
				$('.timeslot .button').addClass('button--disabled').bind('click', false).attr({tabindex: -1, 'aria-disabled': 'true'});
			} else {
				if(itemType === ITEM_TYPE_FLEX_PACK) {
					// Just enable buy button for flex package
					$('.timeslot .button.buy').removeClass('button--disabled').unbind('click', false).attr({tabindex: 0, 'aria-disabled': 'false'}).focus();

					// Untabbable because disabled
					$('.timeslot .button.reserve').addClass('button--disabled').bind('click', false).attr({tabindex: -1, 'aria-disabled': 'true'});
				} else {
					$('.timeslot .button').removeClass('button--disabled').unbind('click', false).attr({tabindex: 0, 'aria-disabled': 'false'});

					// Hide the time selector, then focus on the buy button, because otherwise the focus gets stuck on the time
					// selector when using Windows Narrator screen reader. Afterwards, show the time selector again. All this will
					// happen so fast, the user won't be able to tell the time selector ever disappeared.
					$('.select select').hide();
					$('.timeslot .button.buy').focus();
					$('.select select').show();
				}

				if(queryString == "") {
					$('.timeslot .button').attr('href', function() {
						return $(this).attr('href') + buttonId;
					});
				} else { //ETIX-4446
					$('.timeslot .button.buy').attr('href', function() {
						var targetURL = $(this).attr('href');
						//DEV-14349 Performance
						if(itemType === 0){
							targetURL += (buttonId + '?' + queryString) ;
						}else{
							//DEV-14349 Package
							targetURL = targetURL.replace('/p','/k');
							targetURL += (buttonId + '?' + queryString);
						}
						return targetURL;
					});
					$('.timeslot .button.reserve').attr('href', function() {
						if (campaign_id) {
							return $(this).attr('href') + buttonId + '?' + queryString + '&reserve=true';
						}else {
							return $(this).attr('href') + buttonId + '&' + queryString;
						}
					});
				}
			}
		});

		getSeries(currentDay);
		handleLastAvailableMonth();
	}

	hideDays();

	function hideDays() {
		var rows = $('div.datepicker-days tr');
		for(var j = 0; j < rows.length; j++) {
			var daysOfPreviousMonth = $(rows[j]).find('td.old');
			if(daysOfPreviousMonth.length == 7) {
				daysOfPreviousMonth.css('display', 'none');
			} else if (daysOfPreviousMonth.length > 0) {
				for(var i = 0; i < daysOfPreviousMonth.length - 1; i++) {
					$(daysOfPreviousMonth[i]).css('visibility', 'hidden');
				}
				var lastDayOfPrevousMonth = $(daysOfPreviousMonth[daysOfPreviousMonth.length - 1]);
				lastDayOfPrevousMonth.css('border', '0px');
				lastDayOfPrevousMonth.css('border-right', '1px solid #d8dadf');
			}

			var daysOfNextMonth = $(rows[j]).find('td.new');
			if(daysOfNextMonth.length == 7) {
				daysOfNextMonth.css('display', 'none');
				$(rows[j-1]).find('td:not(.new)').css('border-bottom', '1px solid #d8dadf');
			} else if (daysOfNextMonth.length > 0) {
				daysOfNextMonth.css('border', '0px');
				daysOfNextMonth.css('border-top', '1px solid #d8dadf');
				$(rows[j]).find('td:not(.new)').css('border-bottom', '1px solid #d8dadf');
			}
		}
	}

	// If pressing enter (key 13) on focused date, trigger click
	$(document).on('keydown', $('.datepicker-days td.day:not(.disabled)'), function(e) {
		if (e.keyCode == 13) {
			$("#midnight_message").hide();
			$(e.target).click();
		}
	})

	// If focused on dropdown, hide its focus border and show it on the parent div instead,
	// because box shadow does not display well on the dropdown
	$(document).on('focus', '#js-timeslot .select select', function(e) {
		// attr() is used instead of css() because css() does not allow !important tag
		$(e.target).attr('style', 'outline: none !important');
		$(e.target).closest('.select').attr('style', 'box-shadow: none; border: 1px solid white !important; outline: 2px solid blue !important;');
	})

	// Undo the above on blur
	$(document).on('blur', '#js-timeslot .select select', function(e) {
		// attr() is used instead of css() because css() does not allow !important tag
		$(e.target).attr('style', 'outline: initial !important');
		$(e.target).closest('.select').attr('style', 'box-shadow: none; border: 1px solid #d8dadf !important; outline: none !important;');
	})

  $(window).on('load', function() {
    // When page first loads, month and year are in .month-year span. But if the user changes the month,
    // this span is removed, and month and year are instead in .datepicker-switch (the parent of .month-year).
    const $monthYear = $('.month-year').first();
    $monthYear.attr({
      'aria-label': $monthYear.text() + " - Press tab to cycle through available days for this month",
      'tabindex': 0
    });
  });
});
